import React from "react";
import SCDrawer from "./SCDrawer";
import Divider from "@material-ui/core/Divider/Divider";
import TRadioGroup from "../../../Library/RadioGroups/TRadioGroup";
import * as SCConst from "../NonComponents/SCConst";
import SCLocationsSelector from "../OtherComponents/SCLocationsSelector";

class SCLocationsDrawer extends SCDrawer {
    render() {
        try {
            const configDrawer = this.state.configDrawer;

            const levelRadioGroup = (
                <TRadioGroup
                    itemIndex={configDrawer[SCConst.level] - 1}
                    items={["Site", "SNU", "Province"]}
                    handleChange={this.onRadioChange}
                    info={[
                        [SCConst.level, SCConst.siteLevel],
                        [SCConst.level, SCConst.SNU_Level],
                        [SCConst.level, SCConst.provinceLevel],
                    ]}
                    row={true}
                />
            );

            if (configDrawer === null) {
                return null;
            }

            return (
                <div style={{ margin: "20px" }}>
                    <section>
                        <h5>Choose a level at which to display data</h5>
                        {levelRadioGroup}
                    </section>

                    <Divider />

                    <section style={{ width: 900 }}>
                        <h5>
                            Adjust which locations are displayed. Click a province or SNU to view all SNUs or sites it
                            contains, respectively.{" "}
                        </h5>
                        <SCLocationsSelector
                            config={this.state.configDrawer}
                            configExtra={this.state.configExtraDrawer}
                            onConfigChange={this.props.onConfigChangeSC}
                            selectedCountryCode={this.props.selectedCountryCode}
                            countryObjList={this.props.countryObjList}
                            siteInfo={this.props.siteInfo}
                            mstIDsObj={this.props.mstIDsObj}
                        />
                        {/*<div style={{clear: 'both'}}/>*/}
                    </section>
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCLocationsDrawerDiv"}
                    key={"SCLocationsDrawerDiv"}
                >
                    <h3 key={"SCLocationsDrawerH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCLocationsDrawer;
